<template>
    <div class="pb-64 sm:pb-72 font-satoshi_r">
        <div class="flex flex-col justify-end items-center px-4 sm:px-6">

            <div class="">
                <div class="flex justify-center items-center spinner-bg rounded-full w-12 h-12 mb-5">
                    <img src="@/assets/images/trendupp/Warning.svg" alt="">
                </div>

                <h1 class="text-1xl font-medium text-cream-500 mb-3">
                    {{ formData.title }}
                </h1>

                <p class="text-base font-medium text-gray-x10 pr-6">
                    {{ formData.subtitle }}
                </p>
            </div>

            <div
                v-if="formData?.destination == 'app'"
                class="w-full px-3"
            >
                <a
                    :href="formData.buttonLink"
                    class="button is-primary is-medium is-fullwidth font-satoshi_r mt-20"
                >
                    <span class="text-sm">{{ formData.buttonName }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },

    data() {
        return {
        }
    },

    props: {
        formData: {
			type: Object
		},
    },

    methods: {
    },

    mounted() {
    },
};
</script>

<style scoped>
    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .button {
        border-radius: 12px !important;
    }
</style>
